module.exports = __webpack_public_path__ + "static/media/Town30.44ea0adb.png";